import Vue from 'vue/dist/vue.min.js';
import template from 'shared/meter-selector-button-set.hbs';

Vue.component(
    "ms-button-set",
    {
        props: {
            buttons: Array,
            multiple: { type: Boolean, default: false }, 
            ovalButton: { type: Boolean, default: false }, 
            onChange: Function,
            disabledMessage: String,
            defaultValue: { type: Array, default: [] },
            onTriggerEvent: Function
        },
        data(){
            return {
                values: this.buttons && this.buttons.map(v => !v.disabled && v.value ).map(v => this.defaultValue.indexOf(v) >= 0),
            };
        },
        watch: {
            values: {
                immediate: true,
                handler(v){
                    const ctx = this;
                    const value =  v.reduce((o, e, i) => { if (!e) { return o; } return [...o, ctx.buttons[i]]; } , []);
                    this.onChange  && this.onChange(value);
                }
            }
        },
        computed:  {
        },
        mounted() {
        },
        beforeUnmount() {
        },
        methods: {
            change(i) {
                if (!this.multiple) {
                    const values = [];
                    values[i] =  this.values[i];
                    this.values = values;
                }

                this.onTriggerEvent({ value: this.buttons[i] });
            }
        }, 
        template
    }
);
